import { FC, useContext } from "react";
import TGButton from "src/components/ui/TGButton";
import { TestContext } from "../../store/testContext";
import { AddTestInRegistry } from "../TestsButtons/AddTestInRegistry";

interface IProps {
  closeTests: () => void;
  addTestOnRegistry?: boolean;
  shouldUpdateTestList?: () => void;
}

const TestsFooter: FC<IProps> = ({ closeTests, addTestOnRegistry, shouldUpdateTestList }) => {
  const {
    state: { IsQuestionFormOpen, Questions }
  } = useContext(TestContext);
  const isContinueButtonDisabled = IsQuestionFormOpen || !Questions.length;

  const closeAddTest = () => {
    closeTests();
  };

  return (
    <div>
      {addTestOnRegistry ? (
        <footer className="pb-10 flex justify-between">
          <TGButton color="white" onClick={closeAddTest}>
            Отмена
          </TGButton>
          <AddTestInRegistry shouldUpdateTestList={shouldUpdateTestList} closeTests={closeTests} addTestOnRegistry={addTestOnRegistry} />
        </footer>
      ) : (
        <footer className="pb-10 flex justify-between">
          <TGButton color="white" onClick={closeTests} disabled={IsQuestionFormOpen}>
            Назад
          </TGButton>
          <div className="flex justify-between gap-[10px]">
            <AddTestInRegistry />
            <TGButton color="bluedark" onClick={closeTests} disabled={isContinueButtonDisabled}>
              Продолжить
            </TGButton>
          </div>
        </footer>
      )}
    </div>
  );
};
export default TestsFooter;
